module.exports = __webpack_public_path__ + "img/cannon20ex_icon.c522dac7.png";